import { api } from '@/shared/axios-client';

export type TestScriptIndexStatusValue =
  | 'processing'
  | 'completed'
  | 'failed'
  | 'skipped'
  | 'running'
  | string;

export interface TestScriptIndexStatusPayload {
  repositoryId: string;
  repoName?: string;
  inventoryId: string;
  status: TestScriptIndexStatusValue;
  selectedCount?: number;
  processedCount?: number;
  totalCount?: number;
  phase?: string;
  inserted?: number;
  failed?: number;
  error?: string;
  message?: string;
  buildId?: number;
  commitId?: string;
}

export interface TestScriptIndexStatusResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data: TestScriptIndexStatusPayload | null;
}

export async function getTestScriptIndexStatus(
  repositoryMongoId: string,
): Promise<TestScriptIndexStatusResponse> {
  const res = (await api.get(
    `/api/repositories/${encodeURIComponent(repositoryMongoId)}/test-scripts/index-status`,
  )) as TestScriptIndexStatusResponse;
  return res;
}
